import React from 'react';
import {withStyles, makeStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/lab/Alert';

import axios from '../utils/axiosConfig';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

const StyledTableCell = withStyles(theme => ({
    head: {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  }))(TableCell);

const StyledTableRow = withStyles(theme => ({
root: {
    '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.background.default,
    },
},
}))(TableRow);

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  btnPadding :{
    marginRight: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar
  },
  content: {
    flexGrow: 80,
    padding: theme.spacing(3),
    // overflow:"scroll",
  }
}));

export default function FullWidthGrid(props) {
  const classes = useStyles();
  const {buttonArray, _started, _pending, _buttonName, setButtonClicked, typeButton, 
    setSelectedType, selectTypeButton, _setTestData, _setExamId} = props;
  setSelectedType('PRACTISE');

  const [_tableData, setTabledata] = React.useState({});
  const [modal, setModal] = React.useState(false);
  const [message, setMessage] = React.useState('');
  
  const _handleGroupClick = (item) => {
    setButtonClicked(item);
    
    
  }

  const handleClose = () => {
    setModal(false)
  }

  const modalHandler = (row) => {
    

    axios.post('/dashboard/practice', {
      // axios.post('http://192.168.31.35:3006/v3/dashboard/practice', {
        headers: {
          'Access-Control-Allow-Origin': '*',
        },practice: row
      }).then(practiceData => {
        
        
        setModal(true);
        setMessage((practiceData.data.userExamId !== null || practiceData.data.userExamId !== undefined) ? 
            'Exam is already assigned hence cant assign' : 'Exam is assigned');
      // eslint-disable-next-line unused-imports/no-unused-vars
      }).catch(error => {
        
        
      })
  }
  React.useEffect(() => {
    
  
    if(buttonArray[selectTypeButton] !== undefined){
      
      setButtonClicked(Object.keys(buttonArray[selectTypeButton])[0]);
      setTabledata(buttonArray[selectTypeButton][Object.keys(buttonArray[selectTypeButton])[0]][0]);
      
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buttonArray[selectTypeButton]])

  return (
    <main className={classes.content}>
        
        <div className={classes.toolbar} />
        <h2>{typeButton}</h2>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Button key={`gButton`} className={classes.btnPadding} 
                variant="outlined" color={"primary"} >
                    Practice
            </Button>
               
                
                {/* <Button  className={classes.btnPadding} variant="outlined" color="primary">
                      Primary
                </Button> */}
            
          </Grid>
          
          <Grid item xs={12}>
            <p style={{color: '#B45E9B'}}>Kindly click on the 'Link' under Action column to proceed:</p>
          
            <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="customized table">
                        <TableHead>
                        <TableRow>
                            {
                            
                            ['S.No', 'Test Name', 'Questions', 'Duration (Minutes)', 'Test'].map((item,index) => {
                                return (<StyledTableCell key={index}>{item}</StyledTableCell>)
                            })
                            
                            }
                        
                            {/* <StyledTableCell align="right">Protein&nbsp;(g)</StyledTableCell> */}
                        </TableRow>
                        </TableHead>
                        <TableBody>
                            {buttonArray['PRACTISE'].map((item, index) => (
                                <StyledTableRow key={`pract_${index}`}>
                                    <StyledTableCell component="th" scope="row">
                                    {index+1}
                                    </StyledTableCell>
                                    <StyledTableCell >{item.test_name}</StyledTableCell>
                                    <StyledTableCell >{item.numberofquestions}</StyledTableCell>
                                    <StyledTableCell >{item.duration} </StyledTableCell>
                                    <StyledTableCell >
                                        <Button variant="outlined" color="primary" onClick={() => modalHandler(item)}>
                                            Apply
                                        </Button>
                                    </StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                    </TableContainer>
                    <Snackbar open={modal} autoHideDuration={6000} onClose={handleClose}>
                        <Alert onClose={handleClose} severity={message !== 'Exam is assigned' ? 'error' : "success"}>
                            {message}
                        </Alert>
                    </Snackbar>
          </Grid>
          
        </Grid>
    </main>
  );
}